// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Point } from '@shared/commons/Geometry';
export class TerceraChartMouseEventArgs {
    constructor(ww, ev) {
        this._NeedRedraw = false;
        this.window = ww;
        this._baseEvent = ev;
        this.Button = ev.button;
        this.X = ev.offsetX;
        this.Y = ev.offsetY;
        this.Delta = -1 * parseInt(ev.deltaY);
        this.Location = new Point(this.X, this.Y);
        this.ClientLocation = new Point(ev.clientX, ev.clientY);
    }
    get NeedRedraw() {
        return this._NeedRedraw;
    }
    set NeedRedraw(value) {
        if (this._NeedRedraw === true || value === this._NeedRedraw) {
            return;
        }
        this._NeedRedraw = value;
    }
}
